import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/BaseConditions/ConditionsConstructorPopup.tsx";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { equals } from 'ramda';
import { SearchInput } from '@gmini/ui-kit/lib/SearchInput';
import { Angle } from '@gmini/ui-kit/lib/icons/Angle';
import { InputProgress, TrashWithCross, Button } from '@gmini/ui-kit';
import { Popup, PopupLeftSide, PopupRightSide, PopupTitle, PopupLeftSideHeader, SearchWrapper, GroupList, PropertyItem, GroupTitle, AngleWrapper, PropertyList, PopupRightSideHeader, PopupRightSideTitle, SelectedGroupTitle, GroupListSelected, SelectedAngleWrapper, PropertyItemSelected, PropertyListSelected } from "./ConditionsConstructorPopup.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ConditionsConstructorPopup = function ConditionsConstructorPopup(_ref) {
  var groupedPropertyList = _ref.groupedPropertyList,
      selectedGroupedPropertyList = _ref.selectedGroupedPropertyList,
      onClosePopupAllPropertyList = _ref.onClosePopupAllPropertyList,
      onSaveSelectedPropertyList = _ref.onSaveSelectedPropertyList,
      listPending = _ref.listPending;

  var _React$useState = React.useState(groupedPropertyList),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      groupedPropertyListState = _React$useState2[0],
      setGroupedPropertyListState = _React$useState2[1];

  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      searchValue = _React$useState4[0],
      setSearchValue = _React$useState4[1];

  var _React$useState5 = React.useState([]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      openedGroups = _React$useState6[0],
      setOpenedGroups = _React$useState6[1];

  var _React$useState7 = React.useState(selectedGroupedPropertyList),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      selectedPropertyListState = _React$useState8[0],
      setSelectedPropertyListState = _React$useState8[1];

  var onChangeSearch = React.useCallback(function (value) {
    setSearchValue(value);
  }, []);
  React.useEffect(function () {
    var newGroupedPropertyListState = groupedPropertyList === null || groupedPropertyList === void 0 ? void 0 : groupedPropertyList.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          groupTitle = _ref3[0],
          propertyList = _ref3[1];

      return [groupTitle, propertyList.filter(function (_ref4) {
        var name = _ref4.name;
        return name === null || name === void 0 ? void 0 : name.toLowerCase().includes(searchValue.toLowerCase());
      })];
    });

    if (newGroupedPropertyListState) {
      setGroupedPropertyListState(newGroupedPropertyListState);
    }
  }, [groupedPropertyList, searchValue]);
  React.useEffect(function () {
    setSelectedPropertyListState(selectedGroupedPropertyList);
  }, [selectedGroupedPropertyList]);

  var onToggleExpandGroup = function onToggleExpandGroup(groupTitle) {
    setOpenedGroups(function (prev) {
      return prev.includes(groupTitle) ? prev.filter(function (el) {
        return el !== groupTitle;
      }) : [].concat(_toConsumableArray(openedGroups), [groupTitle]);
    });
  };

  var onSelectProperty = function onSelectProperty(property) {
    setSelectedPropertyListState(function () {
      var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (prev !== null && prev !== void 0 && prev.some(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            _ = _ref6[0],
            propertyList = _ref6[1];

        return propertyList === null || propertyList === void 0 ? void 0 : propertyList.some(function (propertyState) {
          return propertyState.id === property.id;
        });
      })) {
        return prev;
      }

      if (prev !== null && prev !== void 0 && prev.some(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 1),
            groupTitle = _ref8[0];

        return groupTitle === property.groupName;
      })) {
        return prev.map(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
              groupTitle = _ref10[0],
              propertyListState = _ref10[1];

          if (groupTitle === property.groupName) {
            return [groupTitle, [].concat(_toConsumableArray(propertyListState), [property])];
          }

          return [groupTitle, propertyListState];
        });
      }

      return [].concat(_toConsumableArray(prev), [[property.groupName, [property]]]);
    });
  };

  var onDeleteProperty = function onDeleteProperty(property) {
    setSelectedPropertyListState(function (prev) {
      return prev === null || prev === void 0 ? void 0 : prev.map(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
            groupTitle = _ref12[0],
            propertyList = _ref12[1];

        if (groupTitle === property.groupName) {
          return [groupTitle, propertyList.filter(function (_ref13) {
            var id = _ref13.id;
            return id !== property.id;
          })];
        }

        return [groupTitle, propertyList];
      });
    });
  };

  return /*#__PURE__*/_jsxs(Popup, {
    children: [/*#__PURE__*/_jsxs(PopupLeftSide, {
      children: [/*#__PURE__*/_jsx(PopupLeftSideHeader, {
        children: /*#__PURE__*/_jsx(PopupTitle, {
          children: "\u0412\u0441\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430"
        })
      }), /*#__PURE__*/_jsxs(SearchWrapper, {
        children: [/*#__PURE__*/_jsx(InputProgress, {
          show: listPending
        }), /*#__PURE__*/_jsx(SearchInput, {
          placeholder: "\u041F\u043E\u0438\u0441\u043A \u0441\u0432\u043E\u0439\u0441\u0442\u0432",
          value: searchValue,
          onChange: onChangeSearch
        })]
      }), /*#__PURE__*/_jsx(GroupList, {
        children: groupedPropertyListState === null || groupedPropertyListState === void 0 ? void 0 : groupedPropertyListState.map(function (_ref14) {
          var _ref15 = _slicedToArray(_ref14, 2),
              groupTitle = _ref15[0],
              propertyList = _ref15[1];

          if (!(Number(propertyList === null || propertyList === void 0 ? void 0 : propertyList.length) > 0)) {
            return;
          }

          var expandedGroup = openedGroups.includes(groupTitle) || searchValue.length > 0;
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs(GroupTitle, {
              onClick: function onClick() {
                return onToggleExpandGroup(groupTitle);
              },
              children: [/*#__PURE__*/_jsx(AngleWrapper, {
                expanded: expandedGroup,
                children: /*#__PURE__*/_jsx(Angle, {
                  color: expandedGroup ? '#00003D' : 'rgba(53, 59, 96, 0.25)'
                })
              }), groupTitle]
            }), expandedGroup && /*#__PURE__*/_jsx(PropertyList, {
              children: propertyList.map(function (property) {
                return /*#__PURE__*/_jsxs(PropertyItem, {
                  disabled: selectedPropertyListState === null || selectedPropertyListState === void 0 ? void 0 : selectedPropertyListState.some(function (_ref16) {
                    var _ref17 = _slicedToArray(_ref16, 2),
                        _ = _ref17[0],
                        propertyList = _ref17[1];

                    return propertyList === null || propertyList === void 0 ? void 0 : propertyList.some(function (_ref18) {
                      var id = _ref18.id;
                      return id === property.id;
                    });
                  }),
                  onClick: function onClick() {
                    return onSelectProperty(property);
                  },
                  children: [property.name, /*#__PURE__*/_jsx(AngleWrapper, {
                    children: /*#__PURE__*/_jsx(Angle, {
                      color: "#353B60"
                    })
                  })]
                }, property.id);
              })
            })]
          });
        })
      })]
    }), /*#__PURE__*/_jsxs(PopupRightSide, {
      children: [/*#__PURE__*/_jsxs(PopupRightSideHeader, {
        children: [/*#__PURE__*/_jsx(Button, {
          size: "regular",
          color: "secondary",
          onClick: onClosePopupAllPropertyList,
          children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
        }), !equals(selectedGroupedPropertyList, selectedPropertyListState) && /*#__PURE__*/_jsx(Button, {
          size: "regular",
          onClick: function onClick() {
            if (selectedPropertyListState) {
              onSaveSelectedPropertyList(selectedPropertyListState);
            }

            onClosePopupAllPropertyList();
          },
          children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"
        })]
      }), /*#__PURE__*/_jsxs(PopupRightSideTitle, {
        children: ["\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435", Number(selectedPropertyListState === null || selectedPropertyListState === void 0 ? void 0 : selectedPropertyListState.length) > 0 && /*#__PURE__*/_jsx(Button, {
          leftIcon: /*#__PURE__*/_jsx(TrashWithCross, {
            width: "12px",
            height: "14px"
          }),
          onClick: function onClick() {
            return setSelectedPropertyListState([]);
          },
          size: "small",
          color: "tertiary",
          children: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C"
        })]
      }), /*#__PURE__*/_jsx(GroupListSelected, {
        children: selectedPropertyListState === null || selectedPropertyListState === void 0 ? void 0 : selectedPropertyListState.map(function (_ref19) {
          var _ref20 = _slicedToArray(_ref19, 2),
              groupTitle = _ref20[0],
              propertyList = _ref20[1];

          return (propertyList === null || propertyList === void 0 ? void 0 : propertyList.length) > 0 && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(SelectedGroupTitle, {
              children: groupTitle
            }), /*#__PURE__*/_jsx(PropertyListSelected, {
              children: propertyList.map(function (property) {
                return /*#__PURE__*/_jsxs(PropertyItemSelected, {
                  onClick: function onClick() {
                    return onDeleteProperty(property);
                  },
                  children: [/*#__PURE__*/_jsx(SelectedAngleWrapper, {
                    children: /*#__PURE__*/_jsx(Angle, {})
                  }), property.name]
                }, property.id);
              })
            })]
          });
        })
      })]
    })]
  });
};